import { Model } from 'modules/core/lib/mobx-rest'

export interface Argument {
  value: string
  use_variable: boolean
}

export interface ConditionParams {
  id?: string | null | undefined
  path: string
  operator: string
  arguments: Argument[]
}

interface ICondition {
  id?: string
  filter_id?: string
  path?: string
  operator?: string
  arguments?: Argument[]
  created_at?: string
  updated_at?: string
  company_id?: string | null
}

class Condition extends Model<ICondition> {
  static urlRoot() {
    return '/reports/conditions'
  }

  static NOT_DEFINED = '__not_defined__'

  serialize(): ConditionParams {
    return {
      id: this.has('id') ? this.attributes.id : null,
      path: this.attributes.path ?? '',
      operator: this.attributes.operator ?? '',
      arguments: this.attributes.arguments ?? [],
    }
  }
}

export default Condition
